import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { validationClasses } from '@/utils/errors';
import fields from '@/constants/fields';
import { findQueryFilter } from '../../state/shared';

const listItems = (items) => items.map((item) => ({
  key: `cohort_lookup_item_${item.name}`,
  text: item.description,
  value: item.name,
  description: item.name,
}));

const CohortFilterLookupsDropdown = ({
  filterUUID,
  values,
  lookups,
  disabled,
  onChange,
  multiple,
  saveErrors,
}) => {
  const intl = useIntl();
  const placeholder = multiple ? 'cohort.filter.lookups.placeholder' : 'cohort.filter.lookup.placeholder';
  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <Dropdown
      fluid
      search
      selection
      multiple={multiple}
      className={validationClasses(validationError, 'aridhia-cohort-filter-lookups-dropdown max-content')}
      value={multiple ? values : values[0]}
      options={listItems(lookups)}
      disabled={disabled}
      noResultsMessage={intl.formatMessage({ id: 'cohort.filter.no.lookups' })}
      onChange={(e, { value }) => { onChange(multiple ? value : [value]); }}
      placeholder={intl.formatMessage({ id: placeholder })}
    />
  );
};

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { cohort, query, filter } = findQueryFilter(cohorts, ownProps);
  const dictionary = query.dataset.dictionaries.find((r) => (r.code === ownProps.dictionaryCode));

  return (
    {
      values: filter.values,
      saveErrors: cohort.saveErrors,
      lookups: get(dictionary.lookups, `${filter.field.constraints}.options`, []),
    }
  );
};

export default connect(mapStateToProps)(CohortFilterLookupsDropdown);
